import script from "./TemporalCriteria.vue?vue&type=script&setup=true&lang=js"
export * from "./TemporalCriteria.vue?vue&type=script&setup=true&lang=js"

import "./TemporalCriteria.vue?vue&type=style&index=0&id=46de1e3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46de1e3f"]])

export default __exports__